import { render, staticRenderFns } from "./index-drawer.vue?vue&type=template&id=541ff1a6&"
import script from "./index-drawer.vue?vue&type=script&lang=js&"
export * from "./index-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports